import { render, staticRenderFns } from "./UserDetailsFilter.vue?vue&type=template&id=f4c2e810&"
import script from "./UserDetailsFilter.vue?vue&type=script&lang=js&"
export * from "./UserDetailsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports